module.exports = __webpack_public_path__ + "img/ghana.8eabdc19.png";